import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { router } from './routes/routes';

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        richColors
        expand
        toastOptions={{
          style: {
            width: 'max-content',
            maxWidth: '90vw',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            position: 'fixed',
            top: 20,
            right: 20,
          },
        }}
      />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
